<template>
  <PageTable />
</template>
<script>
import PageTable from './table'
export default {
  name: 'plan-orderFlowSettings',
  components: { PageTable },
}
</script>
